import React from "react";

export default function Grafana() {
  const grafanaLink =
    "http://localhost:3000/d-solo/adws9n6/new-dashboard?orgId=1&from=1786156242323&to=1786177842323&timezone=browser&panelId=panel-1&kiosk=1";

  return (
    <div style={{ padding: "20px" }}>
      <h3>آمار لحظه‌ای سیستم</h3>
      <div style={{ height: "350px", width: "100%", borderRadius: "10px", overflow: "hidden", border: "1px solid #ddd" }}>
        <iframe src={grafanaLink} width="100%" height="100%" frameBorder="0" title="چارت تستی" />
      </div>
    </div>
  );
}
